const files = require.context(".", false, /\.js$/);
let modules = {};

files.keys().forEach(key => {
  if (key === "./index.js") return;
  let defaultExport = files(key).default;
  modules.state = { ...modules.state, ...defaultExport.state };
  modules.actions = { ...modules.actions, ...defaultExport.actions };
  modules.mutations = { ...modules.mutations, ...defaultExport.mutations };
  modules.getters = { ...modules.getters, ...defaultExport.getters };
});

export default modules;
